import { PaginationControls } from "../../common/PaginationControls.js";
import { getFirestore } from "firebase/firestore";
import { app } from "../../../firebase-config.js";
import { PlazaService } from "../../../services/plaza.service.js"; // [FIX] Import Service

const db = getFirestore(app);

export class PlazaCommentModal {
    constructor(feedId, feedAuthorId, onUpdate) {
        this.feedId = feedId;
        this.feedAuthorId = feedAuthorId;
        this.onUpdate = onUpdate; // Callback for count sync
        this.overlay = null;
        this.modal = null;
        this.replyTo = null; // { id, authorName }
        this.mentionedUsers = new Map();

        // [UX] Anchoring: Track if user interacted
        this.hasUserCommented = false;
        this.onCloseCallback = null; // Set via setter or reuse onUpdate logic? Better to have explicit setter.
        this.replyTo = null; // { id, authorName }
        this.mentionedUsers = new Map();

        // [Pagination State]
        this.state = {
            comments: [],
            currentPage: 1,
            totalCount: 0,
            cursors: [], // [null, doc1, doc2...]
            isLoading: false
        };

        // Increment View Count immediately on open
        if (feedId) {
            PlazaService.incrementView(feedId);
        }
    }

    close() {
        const el = document.getElementById('plaza-comment-modal');
        if (el) {
            el.classList.add('opacity-0');
            const modal = el.querySelector('div'); // The inner modal div
            if (modal) {
                modal.classList.add('translate-y-full', 'sm:translate-y-10');
            }

            setTimeout(() => {
                if (this.boundDocumentClick) document.removeEventListener('click', this.boundDocumentClick, true);
                if (this.boundSelectionChange) document.removeEventListener('selectionchange', this.boundSelectionChange);
                el.remove();
                if (this.dropdown) this.dropdown.remove(); // Cleanup Portal

                // [UX] Anchoring: Trigger callback if user commented
                if (this.hasUserCommented && this.onCloseCallback) {
                    this.onCloseCallback();
                }
            }, 300);
        } else {
            // Fallback just in case
            if (this.unsubscribe) this.unsubscribe();
            if (this.boundDocumentClick) document.removeEventListener('click', this.boundDocumentClick, true);
            if (this.boundSelectionChange) document.removeEventListener('selectionchange', this.boundSelectionChange);
            if (this.overlay) this.overlay.remove();
            if (this.dropdown) this.dropdown.remove();
        }
    }

    render() {
        if (document.getElementById('plaza-comment-modal')) return;

        const overlay = document.createElement('div');
        overlay.id = 'plaza-comment-modal';
        overlay.className = "fixed inset-0 bg-black/50 z-50 flex items-end sm:items-center justify-center transition-opacity opacity-0";

        let isMouseDownOnOverlay = false;
        overlay.onmousedown = (e) => {
            isMouseDownOnOverlay = e.target === overlay;
        };

        overlay.onclick = (e) => {
            if (e.target === overlay && isMouseDownOnOverlay) this.close();
        };

        const modal = document.createElement('div');
        modal.className = "bg-white dark:bg-zinc-900 w-full max-w-lg h-[80vh] sm:h-[600px] sm:rounded-2xl rounded-t-2xl shadow-2xl flex flex-col transform transition-transform translate-y-full sm:translate-y-10 relative";
        overlay.appendChild(modal);

        // Header
        const header = document.createElement('div');
        header.className = "flex items-center justify-between p-4 border-b border-gray-100 dark:border-zinc-800 shrink-0";
        header.innerHTML = `
            <h3 class="font-bold text-gray-900 dark:text-white text-lg">댓글</h3>
            <button class="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 btn-close rounded-full transition-colors">
                <span class="material-symbols-outlined">close</span>
            </button>
        `;

        const closeBtn = header.querySelector('.btn-close');
        closeBtn.onclick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.close();
        };
        modal.appendChild(header);

        // List Area
        const listArea = document.createElement('div');
        listArea.className = "flex-1 overflow-y-auto p-4 space-y-4 no-scrollbar";
        listArea.innerHTML = `<div class="flex justify-center py-10"><div class="animate-spin rounded-full h-8 w-8 border-b-2 border-violet-500"></div></div>`;
        modal.appendChild(listArea);

        // Pagination Area [NEW]
        const paginationArea = document.createElement('div');
        paginationArea.id = 'comment-pagination';
        // [FIX] Double Border Prevention: PaginationControls adds its own border-t.
        // We just need a shrink-0 container.
        paginationArea.className = "flex justify-center shrink-0 w-full";
        modal.appendChild(paginationArea);
        this.paginationArea = paginationArea;

        // Input Area
        const inputArea = document.createElement('div');
        inputArea.className = "p-4 border-t border-gray-100 dark:border-zinc-800 bg-white dark:bg-zinc-900 shrink-0 sm:rounded-b-2xl pb-safe block relative";

        // [FIX] Portal Dropdown: Append to body to avoid z-index/clipping issues
        this.dropdownId = 'comment-mention-dropdown-portal';
        let existingDropdown = document.getElementById(this.dropdownId);
        if (existingDropdown) existingDropdown.remove(); // Cleanup old if any

        const dropdown = document.createElement('div');
        dropdown.id = this.dropdownId;
        // [FIX] Coordinate System: Use 'absolute' for reliable positioning with scroll
        dropdown.className = "hidden absolute bg-white dark:bg-zinc-800 rounded-xl shadow-xl border border-gray-100 dark:border-zinc-700 overflow-hidden z-[9999] max-h-40 overflow-y-auto w-64";
        document.body.appendChild(dropdown);
        this.dropdown = dropdown;

        // Reply Indicator
        const replyIndicator = document.createElement('div');
        replyIndicator.id = 'reply-indicator';
        replyIndicator.className = "text-xs text-gray-500 mb-2 flex items-center justify-between hidden px-2 py-1 bg-gray-50 dark:bg-zinc-800 rounded";
        replyIndicator.innerHTML = `
            <span><span class="font-bold text-violet-500" id="reply-target-name">@User</span>님에게 답글 작성 중...</span>
            <button class="ml-2 text-gray-400 hover:text-gray-600" id="btn-cancel-reply"><span class="material-symbols-outlined text-sm">close</span></button>
        `;
        inputArea.appendChild(replyIndicator);

        const inputForm = document.createElement('div');
        inputForm.className = "flex gap-2";
        inputForm.innerHTML = `
            <div class="w-8 h-8 rounded-full bg-gray-200 dark:bg-zinc-800 overflow-hidden shrink-0">
                 ${window.user?.photoURL
                ? `<img src="${window.user.photoURL}" class="w-full h-full object-cover">`
                : `<span class="material-symbols-outlined text-gray-400 w-full h-full flex items-center justify-center text-sm">person</span>`
            }
            </div>
            <div class="flex-1 relative">
            <div class="flex-1 relative">
                <textarea id="plaza-comment-input" rows="1" class="w-full bg-gray-50 dark:bg-zinc-800 border border-gray-200 dark:border-zinc-700 rounded-xl px-4 py-3 text-base focus:outline-none focus:border-violet-500 focus:ring-1 focus:ring-violet-500 resize-none overflow-hidden pr-12 dark:text-white placeholder-gray-400 leading-normal" placeholder="${window.user ? '댓글을 남겨주세요... (@멘션)' : '로그인이 필요합니다.'}" ${!window.user ? 'disabled' : ''}></textarea>
                <button id="plaza-comment-submit" class="absolute right-2 top-1/2 -translate-y-1/2 text-violet-500 font-bold text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:text-violet-600 transition-colors p-1" disabled>
                    게시
                </button>
            </div>
        `;
        inputArea.appendChild(inputForm);
        modal.appendChild(inputArea);

        document.body.appendChild(overlay);
        this.overlay = overlay;
        this.modal = modal;
        this.listArea = listArea;
        this.inputArea = inputArea;
        this.input = inputArea.querySelector('#plaza-comment-input');

        // Reply Cancel Logic
        replyIndicator.querySelector('#btn-cancel-reply').onclick = () => {
            this.setReplyTarget(null);
        };

        requestAnimationFrame(() => {
            overlay.classList.remove('opacity-0');
            modal.classList.remove('translate-y-full', 'sm:translate-y-10');
        });

        this.setupInput(inputArea);
        this.setupInput(inputArea);
        this.loadData();
    }

    setReplyTarget(target) {
        this.replyTo = target; // { id, name } or null
        const indicator = this.inputArea.querySelector('#reply-indicator');

        if (target) {
            indicator.classList.remove('hidden');
            indicator.querySelector('#reply-target-name').innerText = `@${target.name}`;
            this.input.placeholder = "답글을 입력하세요...";
            this.input.focus();
        } else {
            indicator.classList.add('hidden');
            this.input.placeholder = "댓글을 남겨주세요... (@멘션)";
        }
    }

    setupInput(container) {
        const input = this.input;
        const submitBtn = container.querySelector('#plaza-comment-submit');

        if (!window.user) return;

        input.oninput = (e) => {
            input.style.height = 'auto';
            input.style.height = (input.scrollHeight) + 'px';
            submitBtn.disabled = input.value.trim().length === 0;
            this.handleInput(e);
        };

        submitBtn.onclick = async () => {
            const content = input.value.trim();
            if (!content) return;

            submitBtn.disabled = true;

            try {
                // Collect mentions
                const mentions = [];
                this.mentionedUsers.forEach((uid, name) => {
                    if (content.includes(`@${name}`)) {
                        mentions.push(uid);
                    }
                });

                // Use PlazaService
                await PlazaService.addComment(this.feedId, {
                    content: content,
                    authorId: window.user.uid,
                    authorName: window.user.displayName || window.user.email.split('@')[0] || '익명',
                    authorPhoto: window.user.photoURL || null,
                    parentId: this.replyTo ? this.replyTo.id : null,
                    mentions: mentions
                });

                // Reset
                input.value = '';
                input.style.height = 'auto';
                submitBtn.disabled = true;
                this.setReplyTarget(null);
                this.mentionedUsers.clear();
                this.hideDropdown();

                // [FIX] Optimistic + Stale Protection
                // Immediate update + Enforce minimum on reload
                const optimisticCount = (this.state.totalCount || 0) + 1;
                this.state.totalCount = optimisticCount;

                // [UX] Anchoring: Mark as commented
                this.hasUserCommented = true;

                if (this.onUpdate) this.onUpdate(optimisticCount);

                // Reload Page 1 (This fetches fresh comments)
                // Enforce ensureMin to prevent reverting to 0
                this.state.currentPage = 1;
                this.state.cursors = [];
                await this.loadData({ ensureMin: optimisticCount });

                // onUpdate is called inside loadData with the FRESH server count.

            } catch (e) {
                console.error("Comment Error:", e);
                alert("댓글 등록 실패: " + e.message);
                submitBtn.disabled = false;
            }
        };

        // Close dropdown via document click (Restored with safety flag)
        this.boundDocumentClick = (e) => {
            if (this.dropdown && !this.dropdown.contains(e.target) && e.target !== input) {
                this.hideDropdown();
            }
        };
        document.addEventListener('click', this.boundDocumentClick);
    }

    // --- Mention Logic (Index-Based Robust Fix) ---
    async handleInput(e) {
        const input = e.target;
        const value = input.value;
        const cursor = input.selectionStart;

        // [FIX] Support spaces in nicknames using lastIndexOf
        const textUpToCursor = value.substring(0, cursor);
        const lastAt = textUpToCursor.lastIndexOf('@');

        if (lastAt === -1) {
            this.hideDropdown();
            return;
        }

        const charBeforeAt = lastAt > 0 ? textUpToCursor[lastAt - 1] : '';
        if (charBeforeAt && !/\s/.test(charBeforeAt)) {
            this.hideDropdown();
            return;
        }

        const searchTerm = textUpToCursor.substring(lastAt + 1);

        if (searchTerm.length > 20) {
            this.hideDropdown();
            return;
        }

        // [FIX] Race Condition: Abort previous request
        if (this.searchAbortController) {
            this.searchAbortController.abort();
        }
        this.searchAbortController = new AbortController();
        const signal = this.searchAbortController.signal;

        try {
            const users = await PlazaService.searchUsers(searchTerm);

            if (signal.aborted) return;

            if (users.length > 0) {
                this.showDropdown(users, searchTerm, this.input, lastAt);
            } else {
                this.hideDropdown();
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error("Mention search error:", error);
            }
        }
    }

    showDropdown(users, searchTerm, inputEl, atIndex) {
        this.dropdown.innerHTML = '';
        this.dropdown.classList.remove('hidden');

        const inputRect = inputEl.getBoundingClientRect();
        const spaceBelow = window.innerHeight - inputRect.bottom;

        // [FIX] Coordinate System: Absolute positioning logic
        let topPos;
        if (spaceBelow < 250) {
            topPos = (inputRect.top + window.scrollY - this.dropdown.offsetHeight - 5);
        } else {
            topPos = (inputRect.bottom + window.scrollY + 5);
        }

        this.dropdown.style.top = topPos + 'px';
        this.dropdown.style.left = (inputRect.left + window.scrollX) + 'px';

        users.forEach(user => {
            const item = document.createElement('div');
            item.className = "px-4 py-2 hover:bg-gray-50 dark:hover:bg-zinc-700 cursor-pointer flex items-center gap-2 border-b border-gray-50 dark:border-zinc-700 last:border-0";
            item.innerHTML = `
                ${user.photoURL
                    ? `<img src="${user.photoURL}" class="w-6 h-6 rounded-full object-cover">`
                    : `<div class="w-6 h-6 rounded-full bg-violet-100 text-violet-600 flex items-center justify-center font-bold text-[10px]">${this.escapeHtml(user.displayName)?.[0] || 'U'}</div>`
                }
                <div class="flex flex-col">
                    <span class="text-xs font-bold text-gray-900 dark:text-gray-100">${this.escapeHtml(user.displayName) || 'Unknown'}</span>
                    <span class="text-xs text-gray-400">@${user.email?.split('@')[0]}</span>
                </div>
            `;

            // [FIX] Mobile Touch Defense
            const selectHandler = (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.selectUser(user, atIndex);
            };

            item.ontouchstart = selectHandler;
            item.onmousedown = selectHandler;

            this.dropdown.appendChild(item);
        });
    }

    hideDropdown() {
        this.dropdown.classList.add('hidden');
        this.currentMentionStart = null;

        // Hide Backdrop
        const backdrop = document.getElementById('mention-backdrop');
        if (backdrop) backdrop.style.display = 'none';
    }

    selectUser(user, atIndex) {
        const text = this.input.value;
        const cursor = this.input.selectionStart;

        // Verify AtIndex safety
        if (atIndex < 0 || atIndex >= text.length) return;

        const before = text.substring(0, atIndex);
        const after = text.substring(cursor);

        const newText = before + `@${user.displayName} ` + after;

        this.input.value = newText;
        this.input.focus();
        const newCursorPos = atIndex + user.displayName.length + 2;
        this.input.setSelectionRange(newCursorPos, newCursorPos);

        this.hideDropdown();
        this.mentionedUsers.set(user.displayName, user.uid);
    }

    // --- Pagination Logic [NEW] ---
    async loadData(options = {}) {
        this.state.isLoading = true;
        this.listArea.style.opacity = '0.5';

        try {
            // 1. Fetch Feed Info (for count) if needed (or assume passed / updated)
            // We need TOTAL count for pagination.
            // Efficient: Get feed doc once or pass it.
            // Let's fetch feed doc to be sure of current count.
            // [FIX] Support Forced Server Fetch
            const fetchOpts = options.forceServer ? { source: 'server' } : {};
            const feedData = await PlazaService.getFeed(this.feedId, fetchOpts);

            this.state.totalCount = feedData ? (feedData.commentCount || 0) : 0;
            if (this.onUpdate) this.onUpdate(this.state.totalCount);

            // 2. Fetch Comments
            const cursor = this.state.currentPage === 1 ? null : this.state.cursors[this.state.currentPage - 2];

            // [FIX] Use getComments (renamed from fetchComments)
            const result = await PlazaService.getComments(this.feedId, 20, cursor, fetchOpts);
            this.state.comments = result.comments;

            // 3. Update Cursor stack
            if (result.lastDoc) {
                this.state.cursors[this.state.currentPage - 1] = result.lastDoc;
            }

            // 4. Render
            this.renderComments();
            this.renderPagination();

        } catch (e) {
            console.error("Load Comments Error", e);
            this.listArea.innerHTML = `<div class="text-center py-10 text-red-500">불러오기 실패</div>`;
        } finally {
            this.state.isLoading = false;
            this.listArea.style.opacity = '1';
        }
    }

    renderPagination() {
        if (!this.paginationArea) return;

        const totalPages = Math.ceil(this.state.totalCount / 20) || 1;

        PaginationControls.render({
            target: this.paginationArea,
            currentPage: this.state.currentPage,
            totalPages: totalPages,
            isCompact: true, // [UI FIX]
            onPageChange: (newPage) => {
                this.state.currentPage = newPage;
                this.loadData();
            }
        });
    }

    renderComments() {
        const comments = this.state.comments;

        if (comments.length === 0) {
            this.listArea.innerHTML = `
                <div class="flex flex-col items-center justify-center py-20 text-gray-400">
                    <span class="material-symbols-outlined text-4xl mb-2 opacity-50">chat_bubble_outline</span>
                    <p class="text-sm">가장 먼저 댓글을 남겨보세요!</p>
                </div>
            `;
            return;
        }

        // Group: Roots vs Replies
        // [NOTE] Pagination limits fetching. Replies might be split across pages if chronologically sorted mixing roots and replies.
        // Ideally, we fetch "Roots" paginated, and fetch "Replies" for those roots.
        // Current 'fetchComments' is flat chronological.
        // This means a reply might appear on Page 2 while Root is on Page 1.
        // This is a known trade-off of flat pagination.
        // For now, we render what we have.

        const roots = comments.filter(c => !c.parentId);
        const replies = comments.filter(c => c.parentId);

        // However, if we only fetch 20 items, and they are mixed, we might miss roots.
        // A robust comment system typically fetches "Roots" (where parentId == null) paginated.
        // And then fetches "Replies" for those roots separately (or `array-contains`).
        // Given current structure (flat collection), 'fetchComments' gets ALL mixed.
        // We will render standard list, but threaded UI might look broken if root is missing.
        // Fallback: Render orphans as roots if their parent isn't here?
        // Or just render flat list? Threaded is better.
        // Let's try to render orphans as top-level for now to avoid hiding them.

        const knownRootIds = new Set(roots.map(r => r.id));
        const orphans = replies.filter(r => !knownRootIds.has(r.parentId));

        // This is tricky. If we switch to pagination, "Threading" becomes hard with flat query.
        // Let's render as Flat List for stability OR
        // Stick to threading but acknowledge orphans.
        // Render: Roots + Orphans (as pseudo-roots)

        const displayRoots = [...roots, ...orphans].sort((a, b) => a.createdAt?.seconds - b.createdAt?.seconds);

        this.listArea.innerHTML = '';
        const threadContainer = document.createElement('div');
        threadContainer.className = "flex flex-col gap-6";

        displayRoots.forEach(root => {
            const rootWrapper = document.createElement('div');
            rootWrapper.className = "flex flex-col gap-3";

            rootWrapper.appendChild(this.createCommentItem(root, false));

            // If it's a real root, find its replies in *processed* batch
            if (!root.parentId) {
                const myReplies = replies.filter(r => r.parentId === root.id);
                if (myReplies.length > 0) {
                    const replyContainer = document.createElement('div');
                    replyContainer.className = "pl-11 flex flex-col gap-3 relative";
                    myReplies.forEach(reply => {
                        replyContainer.appendChild(this.createCommentItem(reply, true));
                    });
                    rootWrapper.appendChild(replyContainer);
                }
            } else {
                // It's an orphan (reply without parent in this batch)
                // Render it slightly differently? Or just as is.
                // Indent slightly to indicate it's a reply context?
                // For now, render as root but maybe add visual cue?
            }

            threadContainer.appendChild(rootWrapper);
        });

        this.listArea.appendChild(threadContainer);
    }

    createCommentItem(data, isReply) {
        const div = document.createElement('div');
        div.className = "flex gap-3 items-start animate-fade-in group";
        div.setAttribute('data-comment-id', data.id);

        const isMe = window.user && window.user.uid === data.authorId;
        const isAdmin = window.user && (window.user.role === 'admin' || window.user.role === 'super_admin');
        const canDelete = isMe || isAdmin;

        const date = data.createdAt ? new Date(data.createdAt.seconds * 1000).toLocaleString([], { month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '...';

        div.innerHTML = `
             <div class="${isReply ? 'w-6 h-6' : 'w-9 h-9'} rounded-full overflow-hidden shrink-0 bg-gray-100 dark:bg-zinc-800">
                ${data.authorPhoto
                ? `<img src="${data.authorPhoto}" class="w-full h-full object-cover">`
                : `<div class="w-full h-full flex items-center justify-center text-xs font-bold text-gray-500">${this.escapeHtml(data.authorName)?.[0]}</div>`
            }
            </div>
            <div class="flex-1 min-w-0">
                <div class="flex items-center gap-2 mb-0.5">
                    <span class="text-sm font-bold text-gray-900 dark:text-gray-100 cursor-pointer hover:underline" onclick="window.router.navigate('/user/${data.authorId}')">${this.escapeHtml(data.authorName)}</span>
                    <span class="text-[10px] text-gray-400">${date}</span>
                </div>
                <p class="text-sm text-gray-800 dark:text-gray-200 leading-relaxed whitespace-pre-line font-medium">${this.formatContent(data.content)}</p>
                
                <div class="flex items-center gap-3 mt-1.5 opacity-100 sm:opacity-0 group-hover:opacity-100 transition-opacity">
                    <button class="text-xs text-gray-400 font-bold hover:text-gray-600 dark:hover:text-gray-300 btn-reply">답글 달기</button>
                    ${canDelete ? `
                        <button class="text-xs text-red-300 hover:text-red-500 btn-delete">삭제</button>
                    ` : ''}
                </div>
            </div>
        `;

        // Reply Action
        div.querySelector('.btn-reply').onclick = () => {
            const realParentId = data.parentId || data.id;
            this.setReplyTarget({ id: realParentId, name: data.authorName });
        };

        if (canDelete) {
            div.querySelector('.btn-delete').onclick = async () => {
                if (confirm("댓글을 삭제하시겠습니까?")) {
                    await PlazaService.deleteComment(this.feedId, data.id);
                }
            };
        }

        return div;
    }

    escapeHtml(text) {
        if (!text) return '';
        return text
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
    }

    formatContent(content) {
        if (!content) return '';

        // [SECURITY] Escape HTML first (allowing quotes)
        const escaped = this.escapeHtml(content);

        // Linkify Mentions (Simple visualization)
        // Does not look up UID, just highlights @Name
        return escaped.replace(/(@[\w가-힣]+)/g, '<span class="text-violet-500 font-bold">$1</span>');
    }

    // [UX] Target Lock & Highlight
    scrollToComment(commentId) {
        if (!commentId) return;

        // 1. Wait for render (MutationObserver or Retry logic)
        // Since loadData is async, we might need to retry a few times
        let attempts = 0;
        const findAndScroll = () => {
            const el = this.listArea.querySelector(`[data-comment-id="${commentId}"]`);
            if (el) {
                // Found it!
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });

                // Add Highlight Effect
                el.classList.add('ring-2', 'ring-indigo-500', 'bg-indigo-50/50', 'dark:bg-indigo-900/20', 'rounded-xl', 'transition-all', 'duration-1000');

                // Remove highlight after 3s
                setTimeout(() => {
                    el.classList.remove('ring-2', 'ring-indigo-500', 'bg-indigo-50/50', 'dark:bg-indigo-900/20');
                }, 3000);
            } else {
                attempts++;
                if (attempts < 10) setTimeout(findAndScroll, 500); // Retry every 0.5s up to 5s
            }
        };

        findAndScroll();
    }
}
